@if (pasoActual === 'contrasena') {
  <div>
    <div class="row justify-content-between align-items-center mdc-dialog__title">
      <h5 class="col-10 col-md-10 mb-0 text-left">Autentificación</h5>
      <div class="col-2 col-md-auto col-2">
        <i (click)="closeDialog()" class="fas fa-times icon-close"></i>
      </div>
    </div>
    <mat-dialog-content>
      <div class="row m-0 pt-3 justify-content-center" [formGroup]="formIniciar">
        <h1 class="col-12 text-center mb-5 letrasPortal">Atlas Conmigo</h1>
        <p class="col-12 text-center">Estimado usuario, verifique el alias o sobrenombre que definió previamente.</p>
        <hr class="col-12">
        <h5 class="col-12 m-3 text-center">Bienvenido {{data.alias}}</h5>
        <a class="col-12 mb-3 text-center">Si su alias o sobrenombre es el correcto, por favor ingrese su contraseña</a>
        <div class="col-md-6">
          <mat-form-field class="w-100">
            <input #passwordInput autofocus matInput placeholder="Contraseña" formControlName="Password" (keydown.enter)="validarStep()"
              [type]="hide ? 'password' : 'text'">
              <span matSuffix class="d-flex align-items-center">
                <button mat-icon-button matSuffix (click)="hide = !hide"
                  [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide">
                  <mat-icon>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                </button>
              </span>
              <mat-error>El campo es requerido</mat-error>
            </mat-form-field>
            @if (msgError) {
              <p class="text-right error-inicio">{{msgError}}</p>
            }
            <p class="text-right contrasenia">
              <a (click)="restablecerPassword()">¿Olvidaste tu contraseña?</a>
            </p>
            <p class="text-right mensaje-procesando">@if (procesando) {
              <span><i class="fas fa-sync fa-spin"></i> Procesando...</span>
            }</p>
          </div>
          <hr class="col-12">
          <p class="col-12 text-center">
            En Seguros Atlas nunca solicitamos a nuestros clientes y socios información confidencial tales como usuarios, contraseñas o NIP.
          </p>
        </div>
      </mat-dialog-content>
      <mat-dialog-actions class="row m-0 justify-content-center pb-5">
        <div class="col-auto">
          <!-- [mat-dialog-close]="true" -->
          <button mat-raised-button color="primary" [disabled]="formIniciar.invalid || loading" (click)="validarStep()">
            @if (!loading) {
              <span>Iniciar sesión</span>
            }
            @if (loading) {
              <span><i class="fas fa-sync fa-spin"></i> Cargando...</span>
            }
          </button>
        </div>
      </mat-dialog-actions>
    </div>
  }
  @if (pasoActual === 'codigo') {
    <div>
      <div class="row justify-content-between align-items-center mdc-dialog__title">
        <h5 class="col-10 col-md-10 mb-0 text-left">Verificación de dos pasos</h5>
        <div class="col-2 col-md-auto col-2">
          <i (click)="closeDialog()" class="fas fa-times icon-close"></i>
        </div>
      </div>
      <mat-dialog-content>
        <div class="row m-0 pt-3 justify-content-center" [formGroup]="formIniciar">
          <h1 class="col-12 text-center mb-3 letrasPortal">Atlas Conmigo</h1>
          <p class="col-12 text-center">Este paso extra nos indica que eres tú quien está intentando iniciar sesión.</p>
          <hr class="col-12">
          <h5 class="col-12 m-3 text-center">Tu código expira en: {{formatTime(intervalo)}}</h5>
          <a class="col-12 mb-3 text-center">Para continuar, ingrese el código de verificación de 6 dígitos que enviamos a su correo electrónico <b><small>{{maskedEmail}}</small></b>  o a su número de teléfono móvil <b><small>{{maskedPhone}}</small></b>. </a>
          <div class="col-md-6">
            <mat-form-field class="w-100">
              <input type="password" #twoFactorCodeInput autofocus matInput maxlength="6" placeholder="Escribe el código" formControlName="TwoFactorCode" (keydown.enter)="login()">
              @if (!msgError) {
                <mat-error>El campo es requerido</mat-error>
              }
              @if (msgError) {
                <mat-error>{{msgError}}</mat-error>
              }
            </mat-form-field>
            <p class="text-right contrasenia">
              <a  class="contrasenia"
                [class.disabled]="intervalo != 0"
                [style.pointer-events]="intervalo != 0 ? 'none' : 'auto'"
                [style.cursor]="intervalo != 0 ? 'default' : 'pointer'"
                (click)="intervalo == 0 && getCode()">
                {{ intervalo === 0 ? ' Solicitar nuevo código' : 'Vuelve a intentarlo después de que el código actual expire.' }}
              </a>
            </p>
            <p class="text-right mensaje-procesando">@if (procesando) {
              <span><i class="fas fa-sync fa-spin"></i> Procesando...</span>
            }</p>
          </div>
          @if (this.formIniciar.get('devicetoken').value != this.tokenGenerico) {
            <div>
              <hr class="col-12">
              <h5 class="col-12 m-3 text-center">¿Confiar en este navegador?</h5>
              <mat-slide-toggle
                class="example-margin"
                color="primary"
                [checked]="false"
                [disabled]="false"
                formControlName="SecureBrowser">
                <a class="col-12 mb-3 text-center">Si eliges confiar en este navegador, no se te pedirá un código de verificación la próxima vez que inicies sesión.</a>
              </mat-slide-toggle>
            </div>
          }
        </div>
      </mat-dialog-content>
      <mat-dialog-actions class="row m-0 justify-content-center pb-5">
        <div class="col-auto">
          <button mat-raised-button color="primary" [disabled]="(formIniciar.invalid && intervalo != 0) || intervalo === 0 || loading" (click)="login()">
            @if (!loading) {
              <span>Iniciar sesión</span>
            }
            @if (loading) {
              <span><i class="fas fa-sync fa-spin"></i> Cargando...</span>
            }
          </button>
        </div>
      </mat-dialog-actions>
    </div>
  }